import { ListItem, Stack, Typography } from '@mui/material';
import { Link, ReferenceField } from 'react-admin';

import { SupplierAvatar } from '../suppliers/SupplierAvatar';
import type { ActivityDealCreated } from '../types';
import { BuyerName } from '../buyers/BuyerName';
import { RelativeDate } from '../misc/RelativeDate';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogDealCreatedProps = {
    activity: ActivityDealCreated;
};

export function ActivityLogDealCreated({
    activity,
}: ActivityLogDealCreatedProps) {
    const context = useActivityLogContext();
    const { deal } = activity;
    return (
        <ListItem disableGutters>
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
                <ReferenceField
                    source="id_pessoa"
                    reference="persons"
                    record={activity}
                    link={false}
                >
                    <SupplierAvatar width={20} height={20} />
                </ReferenceField>
                <Typography
                    component="p"
                    variant="body2"
                    color="text.secondary"
                    flexGrow={1}
                >
                    <ReferenceField
                        source="id_vendedor"
                        reference="salespersons"
                        record={activity}

                    >
                        <BuyerName />
                    </ReferenceField>
                    {' '}gerou OC{' '}
                    <Link to={`/purchaseorders/${deal.id}/show`}>{deal.id}</Link>{' '}
                    {' '}com{' '}
                    <Link to={`/purchaseorders/${deal.id}/show`}>{deal.nome_fornec}</Link>{' '}
                    <RelativeDate date={activity.data_hora} />
                    {/* {context !== 'company' && (
                        <>
                            para{' '}
                            <ReferenceField
                                source="id_pessoa"
                                reference="persons"
                                record={activity}
                                link="show"
                            />{' '}
                            <RelativeDate date={activity.data_hora} />
                        </>
                    )} */}
                </Typography>
                {context === 'company' && (
                    <Typography
                        color="textSecondary"
                        variant="body2"
                        component="span"
                    >
                        <RelativeDate date={activity.data_hora} />
                    </Typography>
                )}
            </Stack>
        </ListItem>
    );
}
